// extracted by mini-css-extract-plugin
export default {"component":"oB7CLy","mobile":"zaqsnA"};